import React, { useReducer, useEffect } from 'react';
import VisibiltyOnIcon from '../../../assets/images/visibility_24px.svg?react';
import VisibiltyOffIcon from '../../../assets/images/visibility_off_24px.svg?react';
import { validate } from '../../../utils/validators';
import './Input.css';

const inputReducer = (state, action) => {
  switch (action.type) {
    case 'CHANGE':
      return {
        ...state,
        value: action.val,
        isValid: validate(action.val, action.validators)
      };
    case 'TOUCH': {
      return {
        ...state,
        isTouched: true
      };
    }
    default:
      return state;
  }
};

const Input = (props) => {
  const [inputState, dispatch] = useReducer(inputReducer, {
    value: props.initialValue || '',
    isTouched: false,
    isValid: props.initialValid || false
  });

  const { id, onInput } = props;
  const { value, isValid } = inputState;

  useEffect(() => {
    onInput(id, value, isValid);
  }, [id, value, isValid, onInput]);

  const changeHandler = (event) => {
    dispatch({
      type: 'CHANGE',
      val: event.target.value,
      validators: props.validators
    });
  };

  const touchHandler = () => {
    dispatch({
      type: 'TOUCH'
    });
  };

  const [isPasswordVisible, setIsPasswordVisible] = React.useState(false);
  const handleEyeIconClick = () => {
    setIsPasswordVisible((isPasswordVisible) => !isPasswordVisible);
  };
  const checkErrorStyle = () => {
    let css;
    if (!inputState.isValid && inputState.isTouched) {
      css = {
        borderBottom: '2px solid #f44336'
      };
    }
    return css;
  };
  const element =
    props.element === 'input' ? (
      <>
        {props.type === 'password' ? (
          <div className="input-container input-pass" style={checkErrorStyle()}>
            <div className="input-password-container">
              <input
                id={props.id}
                type={isPasswordVisible ? 'text' : 'password'}
                placeholder={props.placeholder}
                onChange={changeHandler}
                onBlur={touchHandler}
                value={inputState.value}
                className="input-password"
              />
            </div>
            <div className="eyeIcon-container" onClick={handleEyeIconClick}>
              {isPasswordVisible ? <VisibiltyOffIcon style={{ paddingTop: '1px' }} /> : <VisibiltyOnIcon />}
            </div>
          </div>
        ) : (
          <div className="input-container" style={checkErrorStyle()}>
            <input
              id={props.id}
              type={props.type}
              placeholder={props.placeholder}
              onChange={changeHandler}
              onBlur={touchHandler}
              value={inputState.value}
            />
          </div>
        )}
      </>
    ) : (
      <textarea
        id={props.id}
        rows={props.rows || 3}
        onChange={changeHandler}
        onBlur={touchHandler}
        value={inputState.value}
      />
    );

  return (
    <div className={`form-control ${!inputState.isValid && inputState.isTouched && 'form-control--invalid'}`}>
      <label htmlFor={props.id}>{props.label}</label>
      {element}
      {!inputState.isValid && inputState.isTouched && <p>{props.errorText}</p>}
    </div>
  );
};

export default Input;
